import { render, staticRenderFns } from "./servePerson.vue?vue&type=template&id=1ca4b16f&scoped=true"
import script from "./servePerson.vue?vue&type=script&lang=js"
export * from "./servePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4b16f",
  null
  
)

export default component.exports